import React from 'react';

const CompanyOverview = () => {
  return (
    <div>
      <h2 className="text-4xl font-bold text-black mb-5">
  Company<span className="text-[#680099] ml-2 font-bold">Overview</span>
</h2>


      {/* Scrollable container for the tabs (Vertical Scroll) */}
      <div style={scrollableContainerStyle}>
        {/* Container for the vertically aligned tabs */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>

          {/* Tab 1 */}
          <div style={tabStyle}>
            <div style={{ ...tabColorStyle, backgroundColor: '#f1eaf5' }}>
              <span style={textStyle}>Company Name</span>
            </div>
            <div style={textContainerStyle}>
              <span style={righttextStyle}>Vigovia Travel Technologies Pvt Ltd</span>
            </div>
          </div>

          {/* Tab 2 */}
          <div style={tabStyle}>
            <div style={{ ...tabColorStyle, backgroundColor: '#f1eaf5' }}>
              <span style={textStyle}>Founded</span>
            </div>
            <div style={textContainerStyle}>
              <span style={righttextStyle}>2023</span>
            </div>
          </div>

          {/* Tab 3 */}
          <div style={tabStyle}>
            <div style={{ ...tabColorStyle, backgroundColor: '#f1eaf5' }}>
              <span style={textStyle}>Headquarters</span>
            </div>
            <div style={textContainerStyle}>
              <span style={righttextStyle}>Bengaluru(India) ; Dubai(UAE)</span>
            </div>
          </div>

          {/* Tab 4 */}
          <div style={tabStyle}>
            <div style={{ ...tabColorStyle, backgroundColor: '#f1eaf5' }}>
              <span style={textStyle}>Current Revenue</span>
            </div>
            <div style={textContainerStyle}>
              <span style={righttextStyle}> ₹ 1 Crore (Organic, Without Advertising) </span>
            </div>
          </div>

          {/* Tab 5 */}
          <div style={tabStyle}>
            <div style={{ ...tabColorStyle, backgroundColor: '#f1eaf5' }}>
              <span style={textStyle}>Primary Markets</span>
            </div>
            <div style={textContainerStyle}>
              <span style={righttextStyle}>India , UAE</span>
            </div>
          </div>

          {/* Tab 6 */}
          <div style={tabStyle}>
            <div style={{ ...tabColorStyle, backgroundColor: '#f1eaf5' }}>
              <span style={textStyle}>Strategic Goal</span>
            </div>
            <div style={textContainerStyle}>
              <span style={righttextStyle}>Establish Vigovia As The Premier B2B And B2C Provider Of Customizable Travel And Forex Solution, Delivering Execeptional Experiences To Agents And Direct Consumers.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Styling for the scrollable container (Vertical Scroll)
const scrollableContainerStyle = {
  width: '95%',  // Full width of the parent container
  height: '490px',  // Set a fixed height for vertical scroll
  overflowY: 'auto',  // Enables vertical scrolling
  paddingRight: '10px',  // Optional: space for the scrollbar
  marginBottom: '20px',  // Optional: space after the scrollable area
  scrollbarColor: ' #680099 #f9f9f9', // Set thumb and track color in Firefox
  scrollbarWidth: 'thin',  // Set a thinner scrollbar for Firefox
  marginLeft: '0px',  // Adding left margin to the scrollbar
};

// Webkit styles to customize scrollbar for Chrome, Safari, and Edge
const scrollbarStyles = ` 
  ::-webkit-scrollbar {
    width: 3px;  /* Narrower scrollbar */
  }
  
  ::-webkit-scrollbar-thumb {
    background-color:  #fbf4ff; /* Purple color for scrollbar thumb */
    border-radius: 10px;
  }
  
  ::-webkit-scrollbar-track {
    background: #fbf4ff; /* Light purple color for the scrollbar track */
  }
`;

// Insert custom scrollbar styles into the page
const styleElement = document.createElement('style');
styleElement.innerHTML = scrollbarStyles;
document.head.appendChild(styleElement);

// Styling for each tab
const tabStyle = {
  width: '100%',  // Width of each tab (take full container width)
  height: '65px',  // Height of each tab
  border: '2px solid #680099',  // Border with color #680099
  borderRadius: '15px',  // Curved corners for the outer border
  display: 'flex',  // Using flex to align the left and colored sections
  marginBottom: '12px'  // Space between each tab vertically
};

// Styling for the color section (1/4 of the tab)
const tabColorStyle = {
  width: '25%',  // Cover 1/4 of the tab with color
  height: '100%',
  borderRight: '2px solid #680099',  // Same border on the right side of the colored section
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '15px 15px 15px 15px',  // Rounded corners for the left side of the colored section
};

// Styling for the text inside the left section (the uncolored part)
const textContainerStyle = {
  flex: 1, // Occupy the remaining space
  display: 'flex',
  justifyContent: 'flex-start',  // Align text to the left horizontally
  alignItems: 'center',  // Keep the text vertically centered
  borderRadius: '0 15px 15px 0',  // Rounded corners for the right side of the left section
  textAlign: 'left',  // Align text to the left
  padding: '0 10px'
};

// Styling for the text inside the tab
const textStyle = {
  color: 'black',
  fontWeight: 'bold',
  fontSize: '18px',
};

const righttextStyle = {
  color: 'black',
  fontSize: '18px',
  marginLeft: '30px'
};

export default CompanyOverview;
